import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { isFunction, pick, isObject } from "lodash";
import { connect } from "react-redux";

// Stylesheets
import "./Link.scss";

const SpanLink = (props) => <span {...props}>{props.children}</span>;

SpanLink.propTypes = {
  children: PropTypes.any,
};

const NavLink = (props) => <Link {...props}>{props.children}</Link>;

NavLink.propTypes = {
  children: PropTypes.any,
};

const AnchorLink = ({ children, ...rest }) => {
  let props = { ...rest };
  if (rest.target === "_blank") {
    // Add 'noopener' for better security and performance
    // https://web.dev/external-anchors-use-rel-noopener/
    props = { ...rest, rel: "noopener" };
  }

  return <a {...props}>{children}</a>;
};

AnchorLink.propTypes = {
  children: PropTypes.any,
  target: PropTypes.string,
};

class LinkComponent extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.any,
    href: PropTypes.string,
    linkType: PropTypes.oneOf([
      "primary",
      "primary_inverse",
      "secondary",
      "secondary_inverse",
      "nav",
      "footer",
    ]),
    to: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string,
        hash: PropTypes.string,
        state: PropTypes.object,
      }),
    ]),
    onClick: PropTypes.func,
    appLocation: PropTypes.object,
  };

  getToProps = () => {
    if (isObject(this.props.to)) {
      let search = this.props.appLocation.query;

      // If the search prop in the 'to' prop object is present,
      // strip any beginning ?, replace with & and append to end of this.props.appLocation.query
      if (this.props.to.search) {
        search = `${this.props.appLocation.query}${this.props.to.search.replace(
          "?",
          "&"
        )}`;
      }

      return {
        search,
        ...pick(this.props.to, ["hash", "state", "pathname"]),
      };
    }

    return {
      pathname: this.props.to,
      search: this.props.appLocation.query,
      ...pick(this.props.to, ["hash", "state"]),
    };
  };

  render() {
    const classes = classNames("link", this.props.className, {
      [`link_${this.props.linkType}`]: !!this.props.linkType,
    });
    const { className, appLocation, to, linkType, ...rest } = this.props;

    let linkProps = { ...rest };

    if (this.props.to) {
      const { href, ...rest } = linkProps;
      linkProps = { ...rest };

      // If link has both 'to' and an onClick as in the case of adding a
      // tracking action to onClick, make sure that the onClick is passed.
      if (!isFunction(this.props.onClick)) {
        const { onClick, ...rest } = linkProps;
        linkProps = { ...rest };
      }

      return (
        <NavLink {...linkProps} className={classes} to={this.getToProps()}>
          {this.props.children}
        </NavLink>
      );
    }

    if (this.props.href) {
      return (
        <AnchorLink className={classes} {...linkProps}>
          {this.props.children}
        </AnchorLink>
      );
    }

    return (
      <SpanLink {...linkProps} className={classes}>
        {this.props.children}
      </SpanLink>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    appLocation: state.app.location || {},
  };
};

export default connect(mapStateToProps, {})(LinkComponent);
